import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Col, Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import logo from "../../../assets/imgs/logo_original.png";
import Breadcrumb from "../../../components/Breadcrumb";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class EvaluationPrint extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      matricesExist: false,
      quantityMatrices: 0,
      questionList: [],
      matrixList: [],
      roomPrint: [],
      showModal: false,
      userModal: {
        answers: []
      },
      list_id: 0,
      countPrint: 0,
      previousPath: "/evaluation.list",
      photo: "",
      isEscola10DigitalGroup: false
    };

    this.error = this.error.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Erro", response);
    }
  };

  componentDidMount() {
    axios
      .get(`${URL.api}access/role/getMenuPhoto`, {
        params: {
          school_id: this.props.general.active_roles.school_id,
          group_id: this.props.general.active_roles.group_id
        },
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ photo: resp.data.data });
      });
    if (this.props.user.user_roles) {
      let aux = this.props.user.user_roles.find(
        elem => elem.group_name === "Escola 10 Digital"
      );
      if (aux) {
        this.setState({ isEscola10DigitalGroup: true });
      }
    }

    if (this.props?.location?.state?.previousRoute === "/evaluation/bank") {
      this.setState({ previousPath: "/evaluation/bank" });
    }
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.pullMatrixes();
  }

  pullMatrixes = async () => {
    try {
      const activityResponse = await axios.get(
        `${URL.api}activity/activity/singleView/${this.props.match.params.id}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      );
      const listId = activityResponse.data.data.items[0].obj_id;
      this.setState({ list_id: listId });
      const objMatrix = {
        list_id: listId
      };

      axios
        .post(`${URL.api}evaluation/matrix/list`, objMatrix, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(respMatrixList => {
          const quantityMatrices = respMatrixList.data.data.length;
          const matricesExist = quantityMatrices > 0;
          const quantityQuestions = matricesExist
            ? respMatrixList.data.data[0].questions.length
            : 0;

          this.setState(
            {
              quantityMatrices: quantityMatrices || 1,
              matrixList: respMatrixList.data.data,
              matricesExist,
              list_id: listId,
              quantityQuestions
            },
            () => {
              if (
                !this.state.matricesExist &&
                this.props.profile.user_role[0].group_id === 86
              ) {
                this.generateMatrices();
              }
            }
          );
        }),
        axios
          .get(`${URL.api}evaluation/question/lists/singleView/${listId}`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(respQuestionList => {
            this.setState({
              questionList: respQuestionList.data.data
            });
          });

      this.setState({
        loading: this.props.profile.user_role[0].group_id !== 86
      });

      if (this.props.profile.user_role[0].group_id !== 86) {
        this.pullAllocationsData();
      }
    } catch (error) {
      this.error(error.response.statusText);
    }
  };

  pullAllocationsData = () => {
    let listId = this.state.list_id;
    let objAllocate = {
      activity_id: this.props.match.params.id,
      room_id: 0,
      user_id: 0
    };
    let objApplication = {
      list_id: listId,
      activity_id: this.state.activity_id
    };

    axios
      .all([
        axios.post(`${URL.api}activity/allocate/list`, objAllocate, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}community/room/listAllocation`, {
          params: {
            group_id: this.props.general.active_roles.group_id,
            region_id: this.props.general.active_roles.region_id,
            school_id: this.props.general.active_roles.school_id,
            role_id: this.props.general.active_roles.role_id,
            user_id: this.props.user.user.id,
            with_users: true
          },
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}evaluation/application/list`, objApplication, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (respAllocate, respRoom, respApplication) => {
            for (let i = 0; i < respAllocate.data.data.length; i++) {
              let usersAux = [];
              for (let j = 0; j < respRoom.data.data.length; j++) {
                if (
                  respAllocate.data.data[i].room_id === respRoom.data.data[j].id
                ) {
                  respAllocate.data.data[i].name = respRoom.data.data[j].name;

                  respAllocate.data.data[i].school_name =
                    respRoom.data.data[j].school_name;

                  for (
                    let k = 0;
                    k < respAllocate.data.data[i].users.length;
                    k++
                  ) {
                    for (
                      let l = 0;
                      l < respRoom.data.data[j].users.length;
                      l++
                    ) {
                      if (
                        respRoom.data.data[j].users[l].administrator === false
                      ) {
                        if (
                          respAllocate.data.data[i].users[k].user_id ===
                          respRoom.data.data[j].users[l].user_id
                        ) {
                          respRoom.data.data[j].users[l].note = null;
                          if (respApplication.data.success) {
                            for (
                              let m = 0;
                              m < respApplication.data.data.length;
                              m++
                            ) {
                              if (
                                respApplication.data.data[m].user_id ===
                                  respRoom.data.data[j].users[l].user_id &&
                                respApplication.data.data[m].allocation_id ===
                                  respAllocate.data.data[i].id
                              ) {
                                respRoom.data.data[j].users[l].note =
                                  respApplication.data.data[m].final_grade;

                                respRoom.data.data[j].users[l].photo =
                                  respApplication.data.data[m].photo || null;
                                break;
                              }
                            }
                          }
                          usersAux.push(respRoom.data.data[j].users[l]);
                        }
                      }
                    }
                  }
                }
              }
              respAllocate.data.data[i].users = usersAux;
            }

            this.setState({
              list_id: listId,
              allocateList: respAllocate.data.data,
              roomList: respRoom.data.data,
              loading: false
            });
          },
          error => {
            this.error(error.response.statusText);
          }
        )
      );
  };

  addQuantityMatrices = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    let quantityMatrices = this.state.quantityMatrices + 1;
    if (quantityMatrices > 5) {
      quantityMatrices = 5;
      toastr.error("Erro", "Você pode gerar no máximo 5 matrizes.");
    }
    this.setState({
      quantityMatrices
    });
  };

  subQuantityMatrices = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    let quantityMatrices = this.state.quantityMatrices - 1;
    if (quantityMatrices < 0) {
      quantityMatrices = 0;
      toastr.error("Erro", "O número não pode ser negativo.");
    }
    this.setState({
      quantityMatrices
    });
  };

  generateMatrices = async () => {
    if (this.state.quantityMatrices === 0) {
      toastr.error(
        "Erro",
        "O número de matrizes geradas tem que ser maior do que 0."
      );
    } else {
      let objMatrix = {
        list_id: this.state.list_id,
        quantity: this.state.quantityMatrices,
        activity_id: this.props.match.params.id
      };

      await axios
        .post(`${URL.api}evaluation/matrix/insert`, objMatrix, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            if (resp.data.success) {
              window.location.reload();
            }
          },
          error => {
            this.error(error.response.statusText);
          }
        );
    }
  };

  printAlagoasAnswerCard = () => {
    let myWindow = window.open("", "Cartão resposta");
    const answerOptions = ["A", "B", "C", "D", "E"];
    const optionsHTML = answerOptions
      .map(
        option =>
          `<td>
          <div style="width: 100%; height: 32px; display: flex; align-items: center; justify-content: center;">
            <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">${option}</div>
          </div>
        </td>`
      )
      .join("");
    myWindow.document.write(`
    <!DOCTYPE html>
      <html lang="pt">
      <head>
      <meta charset="UTF-8">
      <title>Cartão de Resposta</title>
      <style>
        html, body {
          margin: 0;
        }
        body {
          font-family: Arial, sans-serif;
          display: flex;
          flex-direction: column;
          gap: 20px;
          padding: 30px 144px 0px 144px;
        }
        .header {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          margin-bottom: 15px;
        }
        .title {
          text-align: center;
        }
        .school-info {
          text-align: left;
        }
        .answer-grid {
          margin-top: 16px;
          width: 70%;
        }
        .answer-grid th, .answer-grid td {
          text-align: center;
        }
        .answer-grid th {
          background-color: #f0f0f0;
        }
        .answer-table {
          display: flex;
          align-items: center;
          justify-content: center;

          padding: 10px 0px 20px 0px;
          border: 1px solid gray;
          border-radius: 5px;
        }
        .fill-info {
          display: flex;
          margin-bottom: 10px;
        }
        .fill-border {
          border-bottom: 1px solid gray;
          width: 100%;
        }
        .instructions {
          padding: 30px 40px 25px 40px;
          border: 1px solid gray;
          border-radius: 5px;
        }
        ol {
          padding: 0;
        }
        li {
          margin-bottom: 5px;
        }
      </style>
      </head>
      <body>

      <div class="header">
        <img src="${
          this.state.isEscola10DigitalGroup ? URL.img + this.state.photo : logo
        }">
      </div>

      <div class="school-info">
        <div class="fill-info">ESCOLA: <div class="fill-border"></div></div>
        <div class="fill-info">ESTUDANTE: <div class="fill-border"></div></div>
        <div class="fill-info">TURMA: <div class="fill-border"></div></div>
        <div class="fill-info">TURNO: <div class="fill-border"></div></div>
        <div class="fill-info">DATA: <div class="fill-border"></div></div>
      </div>

      <div class="instructions">
        <span>ATENÇÃO! Instruções para preenchimento</span>
        <ol>
          <li>Não dobre ou rasure este cartão de respostas</li>
          <li>Marque apenas uma resposta por questão</li>
          <li>Todas as questões devem ser respondidas com caneta azul ou preta</li>
          <li>Responda apenas a quantidade de questões relativas à sua prova</li>
          <li>Preencher totalmente o espaço conforme o modelo abaixo:</li>
        </ol>
      </div>

      <section class="answer-table">
        <table class="answer-grid">
          <tr>
            <th></th>
            <th>A</th>
            <th>B</th>
            <th>C</th>
            <th>D</th>
            <th>E</th>
          </tr>
          ${this.state.matrixList[0].questions
            .map(
              (element, index) => `<tr><td>${index + 1}</td>${optionsHTML}</tr>`
            )
            .join("")}
        </table>
      </section>

      </body>
      </html>
    `);

    setTimeout(() => {
      myWindow.document.close();
      myWindow.focus();
      myWindow.print();
      myWindow.close();
    }, 250);
  };

  printAnswerCard = () => {
    let users = [];
    let qrcode = [];

    if (this.props.profile.user_role[0].group_id === 86) {
      return this.printAlagoasAnswerCard();
    }

    if (this.state.quantityQuestions > 18) {
      toastr.error(
        "",
        "Cartão resposta só pode ser gerado para uma prova de até 18 questões"
      );
    } else if (
      this.state.roomPrint.length === 0 &&
      this.props.profile.user_role[0].group_id !== 86
    ) {
      toastr.error(
        "Erro",
        "Você precisa selecionar pelo menos uma alocação abaixo."
      );
    } else {
      for (let i = 0; i < this.state.roomPrint.length; i++) {
        for (let j = 0; j < this.state.roomList.length; j++) {
          if (parseInt(this.state.roomPrint[i]) === this.state.roomList[j].id) {
            for (let l = 0; l < this.state.roomList[j].users.length; l++) {
              if (this.state.roomList[j].users[l].administrator === false) {
                let allocationId;
                for (let m = 0; m < this.state.allocateList.length; m++) {
                  if (
                    parseInt(this.state.roomPrint[i]) ===
                    this.state.allocateList[m].room_id
                  ) {
                    allocationId = this.state.allocateList[m].id;
                    break;
                  }
                }
                users.push({
                  allocation_id: allocationId,
                  user: this.state.roomList[j].users[l],
                  room: this.state.roomList[j].name
                });
                qrcode.push({
                  allocation_id: allocationId,
                  user_id: this.state.roomList[j].users[l].user_id,
                  quantity: this.state.quantityQuestions
                });
              }
            }
          }
        }
      }
      const evaluationName = this.state.questionList.name;

      axios
        .post(`${URL.api}evaluation/matrix/qrcode`, qrcode, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.setState(
            {
              // eslint-disable-next-line react/no-access-state-in-setstate
              countPrint: this.state.countPrint + 1
            },
            () => {
              let mywindow = window.open(
                "",
                `Cartão resposta${this.state.countPrint}`
              );
              let isChrome = Boolean(mywindow.chrome);
              mywindow.document.write(`<html>
                <html lang='pt'>
              <head>
              <meta charset="UTF-8">
              <title>Título</title>
              </head>
              <body style="-webkit-print-color-adjust: exact !important;">`);

              for (let i = 0; i < users.length; i++) {
                mywindow.document.write(`
                  <div style="page-break-after: always;">
                    <div style="width: 100%; display: flex; position: relative; top: 0; margin-top: 99px;">
                      <div style="width: 33%;">
                        <img
                          src="${URL.public}css/bolinha_preta.png"
                          style="margin-left: 25px;"
                        />
                      </div>
                      <div style="width: 34%; text-align: center; margin-bottom: 44px;">
                        <img src="${logo}" />
                      </div>
                      <div style="width: 33%; text-align: end;">
                        <img
                          src="${URL.public}css/bolinha_preta.png"
                          style="margin-right: 8px;"
                        />
                      </div>
                    </div>
                    <div style="margin-top: -31px;">
                      <div style="height: 200px;">
                        <table style="margin-top: 15px; float: left; margin-left: 60px;">
                          <tbody>
                            <tr style="height: 32px;">
                              <td>
                                <b>ESCOLA:</b>
                              </td>
                              <td>
                                ${this.props.general.active_roles.school_name}
                              </td>
                            </tr>
                            <tr style="height: 32px;">
                              <td>
                                <b>ESTUDANTE:</b>
                              </td>
                              <td>${users[i].user.user_name}</td>
                            </tr>
                            <tr style="height: 32px;">
                              <td>
                                <b>TURMA:</b>
                              </td>
                              <td>${users[i].room}</td>
                            </tr>
                            <tr style="height: 32px;">
                              <td>
                                <b>AVALIAÇÃO:</b>
                              </td>
                              <td>${evaluationName}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style="text-align: center; float: right; margin-right: 45px;">
                          <img src="${resp.data.data[i]}" />
                        </div>
                      </div>
                      <div style="margin-top: 32px">
                        <div style="display: flex; width: 80%; margin: auto;">
                          <div style="width: 50%;">
                            <table style="width: 60%; margin: auto;">
                              <tbody>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 5px; line-height: 1.5;">
                                          Matriz
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          01
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          02
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          03
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          04
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          05
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          06
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          07
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          08
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          09
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div style="width: 50%;">
                            <table style="width: 80%; margin: auto;">
                              <tbody>
                                <tr>
                                  <td style="height: 40px; visibility: hidden;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          00
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          10
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          11
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          12
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          13
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          14
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          15
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          16
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          17
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="height: 40px;">
                                    <div style="display: flex;">
                                      <div style="display: inline-flex; margin: auto;">
                                        <div style="margin-right: 30px; line-height: 1.5;">
                                          18
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          A
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          B
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          C
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2;">
                                          D
                                        </div>
                                        <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; line-height: 1.2;">
                                          E
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="margin-top: 35px;">
                      <div style="width: 50px; height: 50px; border-radius: 50px; background-color: black; float: left; margin-left: 25px"></div>
                      <div style="width: 50px; height: 50px; border-radius: 50px; background-color: black; float: right; margin-right: 25px"></div>
                    </div>
                  </div>;
                `);
              }

              mywindow.document.write(`</body></html>`);

              if (isChrome) {
                setTimeout(() => {
                  mywindow.document.close();
                  mywindow.focus();
                  mywindow.print();
                  mywindow.close();
                }, 250);
              } else {
                mywindow.document.close();
                mywindow.focus();
                mywindow.print();
                mywindow.close();
              }

              return true;
            }
          );
        });
    }
  };

  printEvaluation = (matrix, answer) => {
    const escape = htmlStr =>
      htmlStr
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");

    let questions = [];
    for (let i = 0; i < matrix.questions.length; i++) {
      let options = [];
      let rightAnswer;
      for (let j = 0; j < matrix.questions[i].question_options.length; j++) {
        let text = "";
        let json = JSON.parse(
          matrix.questions[i].question_options[j].description
        );
        for (let m = 0; m < json.length; m++) {
          if (json[m].type === "paragraph") {
            if (m === 0) {
              for (let n = 0; n < json[m].children.length; n++) {
                if (json[m].children[n].italic) {
                  text += `<i>${escape(json[m].children[n].text)}</i>`;
                } else if (json[m].children[n].bold) {
                  text += `<b>${escape(json[m].children[n].text)}</b>`;
                } else {
                  text += escape(json[m].children[n].text);
                }
              }
            } else {
              text += "<p>";

              for (let n = 0; n < json[m].children.length; n++) {
                if (json[m].children[n].italic) {
                  text += `<i>${escape(json[m].children[n].text)}</i>`;
                } else if (json[m].children[n].bold) {
                  text += `<b>${escape(json[m].children[n].text)}</b>`;
                } else {
                  text += escape(json[m].children[n].text);
                }
              }

              text += "</p>";
            }
          } else if (json[m].type === "image") {
            text += `<p><img src="${json[m].url}"></p>`;
          }
        }
        options.push(text);
        if (matrix.questions[i].question_options[j].check_value) {
          rightAnswer = j;
        }
      }

      let text = "";
      let json = JSON.parse(matrix.questions[i].question_text.description);
      for (let j = 0; j < json.length; j++) {
        if (json[j].type === "paragraph") {
          if (j === 0) {
            for (let n = 0; n < json[j].children.length; n++) {
              if (json[j].children[n].italic) {
                text += `<i>${escape(json[j].children[n].text)}</i>`;
              } else if (json[j].children[n].bold) {
                text += `<b>${escape(json[j].children[n].text)}</b>`;
              } else {
                text += escape(json[j].children[n].text);
              }
            }
          } else {
            text += "<p>";

            for (let n = 0; n < json[j].children.length; n++) {
              if (json[j].children[n].italic) {
                text += `<i>${escape(json[j].children[n].text)}</i>`;
              } else if (json[j].children[n].bold) {
                text += `<b>${escape(json[j].children[n].text)}</b>`;
              } else {
                text += escape(json[j].children[n].text);
              }
            }

            text += "</p>";
          }
        } else if (json[j].type === "image") {
          text += `<p><img src="${json[j].url}"></p>`;
        }
      }

      let data = {
        text,
        options,
        right_answer: rightAnswer
      };
      questions.push(data);
    }

    this.setState(
      {
        // eslint-disable-next-line react/no-access-state-in-setstate
        countPrint: this.state.countPrint + 1
      },
      () => {
        let mywindow = window.open("", `Prova ${this.state.countPrint}`);
        let isChrome = Boolean(mywindow.chrome);
        // mywindow.document.write(
        //   `<html><head><title>${this.state.questionList.name}</title>`
        // );

        mywindow.document.write(
          '</head><body style="-webkit-print-color-adjust: exact !important;">'
        );

        mywindow.document.write(
          `<div style="   border: 1px solid #808080; padding:10px; margin-bottom:50px">`
        );

        mywindow.document.write(
          `<div style="width: 100%; text-align: center">`
        );
        mywindow.document.write(
          `<img src="${
            this.state.isEscola10DigitalGroup
              ? URL.img + this.state.photo
              : logo
          }">`
        );
        mywindow.document.write(`</div>`);

        mywindow.document.write(
          `<div style="margin-top:5px; margin-bottom:5px"><b>ESCOLA:</b> ${this.props.general.active_roles.school_name}</div>`
        );
        mywindow.document.write(
          `<div><b>MATRIZ:</b> ${matrix.name.split(" ")[1]}</div>`
        );

        mywindow.document.write(
          `<div style="margin-top:5px; margin-bottom:5px"><b>PROVA:</b> ${this.state.questionList.name}</div>`
        );

        mywindow.document.write(
          `<div style="margin-top:5px; margin-bottom:5px"><b>PROFESSOR:</b> ${
            this.state.isEscola10DigitalGroup
              ? "_____________________________________________________________________"
              : this.props.general.active_roles.role_name
          }</div>`
        );

        mywindow.document.write(
          `<div ><b>ESTUDANTE:</b> __________________________________________________________________________</div>`
        );

        mywindow.document.write(`</div>`);

        // mywindow.document.write(`<hr/>`);
        // mywindow.document.write(
        //   `<div style="text-align: center; margin-bottom: 50px;">${this.state.questionList.name}</div>`
        // );

        for (let i = 0; i < questions.length; i++) {
          mywindow.document
            .write(`<div style="break-inside: avoid;   border: 1px solid #808080; padding:10px;
">`);
          mywindow.document.write(
            `<div><b>QUESTÃO ${i + 1}</b> - ${
              questions[i].text
            }</div></br></br>`
          );
          let options = [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z"
          ];
          for (let j = 0; j < questions[i].options.length; j++) {
            mywindow.document.write(
              `<div style="display: flex"> <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2; ${
                !answer
                  ? ""
                  : questions[i].right_answer === j
                  ? "background-color: black"
                  : ""
              }">${options[j]}</div> <div style="align-self: center">${
                questions[i].options[j]
              }</div></div></br>`
            );
          }
          mywindow.document.write(`</div>`);
          mywindow.document.write(`</div></br></br></br>`);
        }

        mywindow.document.write("</body></html>");

        if (isChrome) {
          setTimeout(() => {
            mywindow.document.close();
            mywindow.focus();
            mywindow.print();
            mywindow.close();
          }, 250);
        } else {
          mywindow.document.close();
          mywindow.focus();
          mywindow.print();
          mywindow.close();
        }

        return true;
      }
    );
  };

  printEvaluationGabarito = (matrix, answer) => {
    let questions = [];
    for (let i = 0; i < matrix.questions.length; i++) {
      let options = [];
      let rightAnswer;
      for (let j = 0; j < matrix.questions[i].question_options.length; j++) {
        let text = "";
        let json = JSON.parse(
          matrix.questions[i].question_options[j].description
        );
        for (let m = 0; m < json.length; m++) {
          if (json[m].type === "paragraph") {
            if (m === 0) {
              text += json[m].children[0].text;
            } else {
              text += `<p>${json[m].children[0].text}</p>`;
            }
          } else if (json[m].type === "image") {
            text += `<p><img src="${json[m].url}"></p>`;
          }
        }
        options.push(text);
        if (matrix.questions[i].question_options[j].check_value) {
          rightAnswer = j;
        }
      }

      let text = "";
      let json = JSON.parse(matrix.questions[i].question_text.description);
      for (let j = 0; j < json.length; j++) {
        if (json[j].type === "paragraph") {
          if (j === 0) {
            text += json[j].children[0].text;
          } else {
            text += `<p>${json[j].children[0].text}</p>`;
          }
        } else if (json[j].type === "image") {
          text += `<p><img src="${json[j].url}"></p>`;
        }
      }

      let data = {
        text,
        options,
        right_answer: rightAnswer
      };
      questions.push(data);
    }

    this.setState(
      {
        // eslint-disable-next-line react/no-access-state-in-setstate
        countPrint: this.state.countPrint + 1
      },
      () => {
        let mywindow = window.open("", `Prova ${this.state.countPrint}`);
        let isChrome = Boolean(mywindow.chrome);
        // mywindow.document.write(
        //   `<html><head><title>${this.state.questionList.name}</title>`
        // );

        mywindow.document.write(
          '</head><body style="-webkit-print-color-adjust: exact !important;">'
        );

        mywindow.document.write(
          `<div style="   border: 1px solid #808080; padding:10px; margin-bottom:50px">`
        );

        mywindow.document.write(
          `<div style="width: 100%; text-align: center">`
        );
        mywindow.document.write(`<img src="${logo}">`);
        mywindow.document.write(`</div>`);

        mywindow.document.write(
          `<div style="margin-top:5px; margin-bottom:5px"><b>ESCOLA:</b> ${this.props.general.active_roles.school_name}</div>`
        );
        mywindow.document.write(
          `<div><b>MATRIZ:</b> ${matrix.name.split(" ")[1]}</div>`
        );

        mywindow.document.write(
          `<div style="margin-top:5px; margin-bottom:5px"><b>PROVA:</b> ${this.state.questionList.name}</div>`
        );

        mywindow.document.write(`</div>`);

        // mywindow.document.write(`<hr/>`);
        // mywindow.document.write(
        //   `<div style="text-align: center; margin-bottom: 50px;">${this.state.questionList.name}</div>`
        // );

        for (let i = 0; i < questions.length; i++) {
          mywindow.document
            .write(`<div style="break-inside: avoid;   border: 1px solid #808080; padding:10px;
">`);
          mywindow.document.write(
            `<div><b>QUESTÃO ${i + 1}</b> - ${
              questions[i].text
            }</div></br></br>`
          );
          let options = [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z"
          ];
          for (let j = 0; j < questions[i].options.length; j++) {
            mywindow.document.write(
              `<div style="display: flex"> <div style="width: 20px; height: 20px; border: 2px solid black; border-radius: 100%; text-align: center; margin-right: 20px; line-height: 1.2; ${
                !answer
                  ? ""
                  : questions[i].right_answer === j
                  ? "background-color: black"
                  : ""
              }">${options[j]}</div> <div style="align-self: center">${
                questions[i].options[j]
              }</div></div></br>`
            );
          }
          mywindow.document.write(`</div>`);
          mywindow.document.write(`</div></br></br></br>`);
        }

        mywindow.document.write("</body></html>");

        if (isChrome) {
          setTimeout(() => {
            mywindow.document.close();
            mywindow.focus();
            mywindow.print();
            mywindow.close();
          }, 250);
        } else {
          mywindow.document.close();
          mywindow.focus();
          mywindow.print();
          mywindow.close();
        }

        return true;
      }
    );
  };

  putNote = (allocate, user) => {
    let objMatrix = {
      list_id: this.state.list_id,
      activity_id: this.props.match.params.id
    };

    let objEvaluation = {
      list_id: this.state.list_id,
      allocation_id: allocate.id,
      user_id: user.user_id
    };

    axios
      .all([
        axios.post(`${URL.api}evaluation/matrix/list`, objMatrix, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}evaluation/application/list`, objEvaluation, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread((respMatrixList, respApplication) => {
          if (
            respApplication.data.success &&
            respApplication.data.data.length > 0
          ) {
            for (let i = 0; i < respMatrixList.data.data.length; i++) {
              if (
                respMatrixList.data.data[i].id ===
                respApplication.data.data[0].matrix_id
              ) {
                user.matrix = i + 1;
              }
            }
            user.answers = [];
            for (
              let i = 0;
              i < respApplication.data.data[0].answers.length;
              i++
            ) {
              let answer = JSON.parse(
                respApplication.data.data[0].answers[i].answer
              );

              let found = false;

              for (let j = 0; j < answer.itemsAnswer.items.length; j++) {
                if (
                  answer.itemsAnswer.answers[0] === answer.itemsAnswer.items[j]
                ) {
                  user.answers.push(j + 1);
                  found = true;
                  break;
                }
              }

              if (!found) {
                user.answers.push(0);
              }
            }
          } else {
            user.answers = [];
            for (let j = 0; j < this.state.quantityQuestions; j++) {
              user.answers.push(0);
            }
            user.matrix = 0;
          }
          user.allocation_id = allocate.id;

          this.setState({
            showModal: true,
            userModal: user
          });
        })
      );
  };

  changeRoomId = event => {
    let roomPrint = [];

    if (event.target.checked) {
      this.state.roomPrint.forEach(item => {
        roomPrint.push(item);
      });
      roomPrint.push(event.target.id);
    } else {
      this.state.roomPrint.forEach(item => {
        if (item !== event.target.id) {
          roomPrint.push(item);
        }
      });
    }

    this.setState({
      roomPrint
    });
  };

  changeMatrix = matrix => {
    let { userModal } = this.state;
    userModal.matrix = matrix;

    this.setState({
      userModal
    });
  };

  changeAnswer = (question, alternative) => {
    let { userModal } = this.state;

    for (let i = 0; i < userModal.answers.length; i++) {
      if (question === i + 1) {
        for (let j = 0; j < 5; j++) {
          if (alternative === j + 1) {
            userModal.answers[i] = alternative;
            break;
          }
        }
      }
    }

    this.setState({
      userModal
    });
  };

  saveAnswer = () => {
    // usar allocateList para atualizar a nota dos usuários
    let obj = {
      allocation_id: this.state.userModal.allocation_id,
      user_id: this.state.userModal.user_id,
      matrix: this.state.userModal.matrix,
      answers: this.state.userModal.answers
    };

    let check = true;
    if (obj.answers.includes(0)) {
      check = false;
      toastr.error("Erro", "Existe resposta em branco.");
    }

    if (obj.matrix === 0) {
      check = false;
      toastr.error("Erro", "Favor escolher a matriz.");
    }

    if (check) {
      axios
        .post(`${URL.api}general/app/answer`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            if (resp.data.success) {
              this.setState(
                {
                  showModal: false,
                  userModal: {
                    answers: [],
                    matrix: 0
                  }
                },
                () => this.pullAllocationsData()
              );
            }
          },
          () => {
            toastr.error("Erro", "Verifique as respostas.");
          }
        );
    }
  };

  changeUserList = userList => {
    if (document.getElementById(userList).style.display !== "none") {
      document.getElementById(userList).style.display = "none";
      document
        .getElementById(`button_${userList}`)
        .classList.remove("fa-chevron-up");
      document
        .getElementById(`button_${userList}`)
        .classList.add("fa-chevron-down");
    } else {
      document.getElementById(userList).style.display = "block";
      document
        .getElementById(`button_${userList}`)
        .classList.remove("fa-chevron-down");
      document
        .getElementById(`button_${userList}`)
        .classList.add("fa-chevron-up");
    }
  };

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            { path: this.state.previousPath, to: this.state.previousPath }
          ]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <>
            <Row>
              {this.state.matricesExist ||
              this.props.profile.user_role[0].group_id === 86 ? (
                <Col md="12">
                  <CCard>
                    <CCardHeader className="d-flex justify-content-between">
                      <h2>{this.state.questionList.name}</h2>
                    </CCardHeader>
                    <CCardBody>
                      {this.state.matrixList.map((item, index) => (
                        <Row
                          key={index}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <Col md="6">
                            {this.props.profile.user_role[0].group_id === 86
                              ? "Matriz única"
                              : item.name}
                          </Col>
                          <Col
                            md="6"
                            style={{ gap: "12px" }}
                            className="d-flex align-items-center justify-content-end text-center"
                          >
                            <CButton
                              color="primary"
                              onClick={() => this.printEvaluation(item, false)}
                            >
                              Imprimir prova
                            </CButton>
                            {this.props.profile.user_role[0].group_id !==
                              86 && (
                              <CButton
                                color="primary"
                                onClick={() =>
                                  this.printEvaluationGabarito(item, true)
                                }
                              >
                                Imprimir gabarito
                              </CButton>
                            )}
                            {this.props.profile.user_role[0].group_id === 86 &&
                              this.state.previousPath ===
                                "/evaluation/bank" && (
                                <CButton
                                  color="primary"
                                  onClick={() => this.printAnswerCard()}
                                >
                                  Imprimir cartão resposta
                                </CButton>
                              )}
                          </Col>
                        </Row>
                      ))}
                    </CCardBody>
                  </CCard>
                  {this.props.profile.user_role[0].group_id !== 86 &&
                    !this.state.loading && (
                      <CCard>
                        <CCardBody>
                          {this.state.allocateList.length === 0 ? (
                            <Row>
                              <Col md="12" className="text-center">
                                Você não está alocado em nenhuma turma.
                              </Col>
                            </Row>
                          ) : (
                            <React.Fragment>
                              <CButton
                                color="primary"
                                className="mb-3"
                                onClick={() => this.printAnswerCard()}
                              >
                                Gerar folha resposta
                              </CButton>
                              {this.state.allocateList.map(
                                (allocate, index) => (
                                  <React.Fragment key={index}>
                                    <Row
                                      style={{
                                        marginTop: "10px",
                                        marginBottom: "10px"
                                      }}
                                    >
                                      <Col md="10">
                                        <Form.Group>
                                          <Form.Check
                                            type="checkbox"
                                            id={allocate.room_id}
                                            label={
                                              <>
                                                {allocate.name}&nbsp;
                                                <span className="text-muted">
                                                  ({allocate.school_name})
                                                </span>
                                              </>
                                            }
                                            onChange={e => this.changeRoomId(e)}
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col
                                        md="2"
                                        style={{ textAlign: "right" }}
                                        onClick={() =>
                                          this.changeUserList(
                                            `room_id_${allocate.room_id}`
                                          )
                                        }
                                      >
                                        <i
                                          className="fa fa-chevron-down lg cursor"
                                          id={`button_room_id_${allocate.room_id}`}
                                        ></i>
                                      </Col>
                                    </Row>
                                    <div
                                      id={`room_id_${allocate.room_id}`}
                                      style={{ display: "none" }}
                                    >
                                      {allocate.users.map((user, index2) => (
                                        <React.Fragment key={index2}>
                                          <div
                                            className="d-flex align-items-center"
                                            style={{
                                              marginTop: "10px",
                                              marginBottom: "10px",
                                              paddingLeft: "40px",
                                              justifyContent: "center",
                                              alignItems: "center"
                                            }}
                                          >
                                            <div className="flex-1 mr-3">
                                              {user.user_name}
                                            </div>
                                            <div className="text-center mr-3">
                                              {user.note}
                                            </div>
                                            <div className="text-center mr-3">
                                              {user.photo && (
                                                <CButton
                                                  color="secondary"
                                                  onClick={() =>
                                                    window.open(
                                                      URL.img + user.photo,
                                                      "_blank"
                                                    )
                                                  }
                                                >
                                                  Ver cartão-resposta
                                                </CButton>
                                              )}
                                            </div>
                                            <div className="text-center mr-3">
                                              <CButton
                                                color="primary"
                                                onClick={() =>
                                                  this.putNote(allocate, user)
                                                }
                                              >
                                                Lançar nota
                                              </CButton>
                                            </div>
                                          </div>
                                        </React.Fragment>
                                      ))}
                                    </div>
                                  </React.Fragment>
                                )
                              )}
                            </React.Fragment>
                          )}
                        </CCardBody>
                      </CCard>
                    )}
                </Col>
              ) : (
                <>
                  <div style={{ alignSelf: "center" }}>
                    Gerar matrizes:&nbsp;
                  </div>
                  <CButton
                    color="primary"
                    onClick={() => this.subQuantityMatrices()}
                  >
                    -
                  </CButton>
                  <div style={{ alignSelf: "center" }}>
                    &nbsp;&nbsp;{this.state.quantityMatrices}&nbsp;&nbsp;
                  </div>
                  <CButton
                    color="primary"
                    onClick={() => this.addQuantityMatrices()}
                  >
                    +
                  </CButton>
                  &nbsp;&nbsp;
                  <CButton
                    color="primary"
                    onClick={() => this.generateMatrices()}
                  >
                    Gerar matrizes
                  </CButton>
                </>
              )}
            </Row>
            <CModal
              show={this.state.showModal}
              onClose={() =>
                this.setState({
                  showModal: false
                })
              }
              size=""
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              closeOnBackdrop={false}
            >
              <CModalHeader closeButton>
                <CModalTitle>Lançar/Corrigir nota</CModalTitle>
              </CModalHeader>
              <CModalBody className="mx-3">
                <Row style={{ marginBottom: "10px", cursor: "pointer" }}>
                  <Col md="12">{this.state.userModal.name}</Col>
                </Row>
                <Row style={{ marginBottom: "10px" }}>
                  <Col md="2">Matriz</Col>
                  <Col md="2" id="0_1">
                    <div
                      onClick={() => this.changeMatrix(1)}
                      style={{
                        cursor: "pointer",
                        backgroundColor:
                          this.state.userModal.matrix === 1 ? "Grey" : "",
                        border: "2px solid black",
                        borderRadius: "100%",
                        textAlign: "center",
                        lineHeight: "1.2",
                        minHeight: "60px",
                        width: "60px",
                        display: "flex",
                        flexDirection: "column",
                        alignContent: "center",
                        justifyContent: "center"
                      }}
                    >
                      A
                    </div>
                  </Col>
                  {this.state.matrixList.length >= 2 ? (
                    <Col md="2" id="0_2">
                      <div
                        onClick={() => this.changeMatrix(2)}
                        style={{
                          cursor: "pointer",
                          backgroundColor:
                            this.state.userModal.matrix === 2 ? "Grey" : "",
                          border: "2px solid black",
                          borderRadius: "100%",
                          textAlign: "center",
                          lineHeight: "1.2",
                          minHeight: "60px",
                          width: "60px",
                          display: "flex",
                          flexDirection: "column",
                          alignContent: "center",
                          justifyContent: "center"
                        }}
                      >
                        B
                      </div>
                    </Col>
                  ) : null}
                  {this.state.matrixList.length >= 3 ? (
                    <>
                      <Col md="2" id="0_3">
                        <div
                          onClick={() => this.changeMatrix(3)}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              this.state.userModal.matrix === 3 ? "Grey" : "",
                            border: "2px solid black",
                            borderRadius: "100%",
                            textAlign: "center",
                            lineHeight: "1.2",
                            minHeight: "60px",
                            width: "60px",
                            display: "flex",
                            flexDirection: "column",
                            alignContent: "center",
                            justifyContent: "center"
                          }}
                        >
                          C
                        </div>
                      </Col>
                      {this.state.matrixList.length >= 4 ? (
                        <>
                          <Col md="2" id="0_4">
                            <div
                              onClick={() => this.changeMatrix(4)}
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  this.state.userModal.matrix === 4
                                    ? "Grey"
                                    : "",
                                border: "2px solid black",
                                borderRadius: "100%",
                                textAlign: "center",
                                lineHeight: "1.2",
                                minHeight: "60px",
                                width: "60px",
                                display: "flex",
                                flexDirection: "column",
                                alignContent: "center",
                                justifyContent: "center"
                              }}
                            >
                              D
                            </div>
                          </Col>
                          {this.state.matrixList.length === 5 ? (
                            <>
                              <Col md="2" id="0_5">
                                <div
                                  onClick={() => this.changeMatrix(5)}
                                  style={{
                                    cursor: "pointer",
                                    backgroundColor:
                                      this.state.userModal.matrix === 5
                                        ? "Grey"
                                        : "",
                                    border: "2px solid black",
                                    borderRadius: "100%",
                                    textAlign: "center",
                                    lineHeight: "1.2",
                                    minHeight: "60px",
                                    width: "60px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignContent: "center",
                                    justifyContent: "center"
                                  }}
                                >
                                  E
                                </div>
                              </Col>
                            </>
                          ) : null}
                        </>
                      ) : null}
                    </>
                  ) : null}
                </Row>
                {this.state.userModal.answers.map((answer, questionsIndex) => (
                  <React.Fragment key={questionsIndex}>
                    <Row style={{ marginBottom: "10px" }}>
                      <Col md="2">{`Questão ${questionsIndex + 1}`}</Col>
                      {this.state.matrixList[0].questions[
                        questionsIndex
                      ].question_options.map((_, index) => (
                        <Col md="2" id={`${questionsIndex + 1}_${index}`}>
                          <div
                            onClick={() =>
                              this.changeAnswer(questionsIndex + 1, index + 1)
                            }
                            style={{
                              cursor: "pointer",
                              backgroundColor:
                                answer === index + 1 ? "Grey" : "",
                              border: "2px solid black",
                              borderRadius: "100%",
                              textAlign: "center",
                              lineHeight: "1.2",
                              minHeight: "60px",
                              width: "60px",
                              display: "flex",
                              flexDirection: "column",
                              alignContent: "center",
                              justifyContent: "center"
                            }}
                          >
                            <span>{String.fromCharCode(65 + index)}</span>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </React.Fragment>
                ))}
                <Row>
                  <Col md="6"></Col>
                  <Col
                    md="6"
                    style={{
                      textAlign: "right",
                      marginBottom: "20px",
                      paddingRight: "30px"
                    }}
                  >
                    <CButton color="primary" onClick={() => this.saveAnswer()}>
                      Salvar
                    </CButton>
                  </Col>
                </Row>
              </CModalBody>
            </CModal>
          </>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationPrint);
